import './position-badge.scss';
import i18n from '../../../../../lib/i18n';
import Position from '../../../../../common/enums/position';

interface IPositionBadgeProps {
    position: Position;
}

export default function PositionBadge({
    position,
}: Readonly<IPositionBadgeProps>) {
    const getPositionText = () => {
        switch (position) {
            case 1:
                return i18n.t('SmartCargas.Rounds.FirstPosition');
            case 2:
                return i18n.t('SmartCargas.Rounds.SecondPosition');
            case 3:
                return i18n.t('SmartCargas.Rounds.ThirdPosition');
            default:
                return '';
        }
    };

    return (
        <div
            className={`position-badge position-${position}`}
            data-testid={`position-badge-${position}`}
        >
            {getPositionText()}
        </div>
    );
}
